import { useState } from "react";
import { NoteAlert } from "@/components/NoteAlert";
import { useSnapshotSection } from "@/components/snapshot/snapshotSection.context";
import { toSydneyDateTimeText } from "./snapshotDropzone.utils";

/**
 * A section's notes as alerts: files uploaded since the snapshot was built (warning) and files that
 * share a name (info). A closed note comes back if its text changes.
 */
export const SnapshotDropzoneNotes = () => {
  const section = useSnapshotSection();
  const [dismissed, setDismissed] = useState<string[]>([]);
  const built = section.builtSnapshot;
  const newCount = section.newSinceBuildKeys.length;
  const duplicateCount = section.duplicates.count;

  let staleText: string | null = null;
  if (section.status === "stale" && built && newCount > 0) {
    const files = newCount === 1 ? "1 file" : `${newCount} files`;
    staleText = `${files} added since this snapshot was built on ${toSydneyDateTimeText(built.builtAt)}. Update it so the import picks up the changes.`;
  }
  let duplicateText: string | null = null;
  if (duplicateCount > 0) {
    duplicateText = `${duplicateCount} files share a name. The build reads them all; where their rows overlap, the newest upload wins.`;
  }

  const dismiss = (text: string) => {
    setDismissed((current) => [...current, text]);
  };

  return (
    <>
      {staleText && !dismissed.includes(staleText) && (
        <NoteAlert
          onClose={() => dismiss(staleText)}
          severity="warning"
          sx={{ mb: 1.5 }}
        >
          {staleText}
        </NoteAlert>
      )}
      {duplicateText && !dismissed.includes(duplicateText) && (
        <NoteAlert
          onClose={() => dismiss(duplicateText)}
          severity="info"
          sx={{ mb: 1.5 }}
        >
          {duplicateText}
        </NoteAlert>
      )}
    </>
  );
};
